//@ts-check

let inited = false;
let callback = null;

/**
 * 
 * @param {PMRule} rule 
 * @param {() => Promise} cb 
 */
module.exports = (rule, cb) => {
	callback = cb;

	if (!inited) {
		inited = true;

		rule.pm.handleEvent('~.Join_Form', 'inited', (p, widget) => {
			const master_onSubmit = widget.onSubmit;

			widget.onSubmit = (data, ...args) => callback().then(({ result, params }) => {
				if (result === true) {
					return master_onSubmit.apply(widget, [data, params, ...args]);
				}
			});
		}, {
			sync: true,
			prefix: 'user_access_patch_join_form'
		});
	}
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/common/patch-join-form.es.js